import { Amplify } from "aws-amplify";
import { fetchAuthSession } from "aws-amplify/auth";

function initialize() {
  // Resource configuration
  const resourcesConfig = {
    Auth: {
      Cognito: {
        userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
        userPoolClientId: import.meta.env.VITE_COGNITO_USER_POOL_WEB_CLIENT_ID,
        loginWith: {
          email: true
        }
      }
    },
    API: {
      REST: {
        [import.meta.env.VITE_API_NAME]: {
          endpoint: import.meta.env.VITE_API_HOST,
          region: import.meta.env.VITE_COGNITO_REGION
        }
      }
    }
  };

  // Library options with async headers
  const libraryOptions = {
    API: {
      REST: {
        headers: async () => {
          try {
            const session = await fetchAuthSession();
            if (session?.tokens?.idToken) {
              return {
                Authorization: `Bearer ${session.tokens.idToken.toString()}`
              };
            }
            return {};
          } catch (error) {
            // User not authenticated yet, return empty headers
            return {};
          }
        }
      }
    }
  };

  Amplify.configure(resourcesConfig, libraryOptions);
}

export default initialize;
